document.addEventListener('DOMContentLoaded', function() {
  function customizeChatStyles() {
    const chatRoot = document.querySelector('#shopify-chat')?.shadowRoot;
    if (chatRoot) {
      const style = document.createElement('style');
      style.textContent = `
        .chat-toggle {
          /* Ihre Anpassungen hier, zum Beispiel: */
          background-color: #yourColor !important;
          border-radius: 10px !important;
        }
        .chat-app {
          /* Weitere Anpassungen */
          font-family: Arial, sans-serif !important;
        }
      `;
      chatRoot.appendChild(style);
    }
  }

  // Initial ausführen
  customizeChatStyles();

  // Erneut ausführen, wenn sich der DOM ändert (für den Fall, dass der Chat dynamisch geladen wird)
  const observer = new MutationObserver((mutations) => {
    if (document.querySelector('#shopify-chat')) {
      customizeChatStyles();
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});